import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult } from '../../rules';
import IsOwnPropertyUnderConstruction from '../../rules/IsOwnPropertyUnderConstruction';

class WillingToProvideCommercialGuarantorRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isOwnPropertyUnderConstructionValue =
      IsOwnPropertyUnderConstruction.evaluate(data);

    return isOwnPropertyUnderConstructionValue
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new WillingToProvideCommercialGuarantorRuleset();
